const MAX_STACK_TRACE_LENGTH = 1000;

/**
 * Truncates a stack trace string to a maximum length to avoid
 * oversized analytics event payloads.
 * Returns undefined if the input is falsy (undefined, null, or empty string).
 */
export const truncateStackTrace = (stack: string | undefined): string | undefined => {
	if (!stack) {
		return undefined;
	}
	if (stack.length <= MAX_STACK_TRACE_LENGTH) {
		return stack;
	}
	return `${stack.substring(0, MAX_STACK_TRACE_LENGTH)}…`;
};
